import React from "react";
import { User } from "firebase/auth";


export const AuthContext = React.createContext({ loading: true, user: null });